export const WmsType = {
  InventoryTransfer: 31,
  PurchaseDelivery: 12,
};

export const WmsStatus = {
  OPENED: 'O',
  CLOSED: 'C',
};
